export default {"src":"/_next/static/media/routing-step.79aa86dd.svg","height":544,"width":624,"blurWidth":0,"blurHeight":0};